/** Student self-view tile; the supervisor frame shrinks to this size on small screens. */
export const SELF_VIEW_CHIP_WIDTH_PX = 120;
export const SELF_VIEW_CHIP_HEIGHT_PX = 90;
export const SELF_VIEW_CHIP_INSET_PX = 16;
